<template>

 <div>
    <h2>总成绩：{{EnglshData.completionPTS}}</h2>
    <div id="main">
 
    </div>
  </div>


</template>

<script>
  import earch from '@/components/work/until/Echarts.js'
export default {
props:['EnglshData'],
data(){
  return{
     performance:[],
  }
},
methods:{

},
mounted(){
var myChart = earch.init(document.getElementById('main'));
myChart.setOption({
  title: {
    text: this.EnglshData.courseName,
    subtext: this.EnglshData.topic,
    left: 'center'
  },
  tooltip: {
    trigger: 'item'
  },
  legend: {
    orient: 'vertical',
    left: 'left'
  },
  series: [
    {
      name: 'Access From',
      type: 'pie',
      radius: '50%',
      data: [
        { value: this.EnglshData.completion1, name: '（1）' },
        { value: this.EnglshData.completion2, name: '（2）' },
        { value: this.EnglshData.completion3, name: '（3）' },
        { value: this.EnglshData.completion4, name: '（4）' },
       
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
});

}
}

</script>

<style scoped>

  
h2{
    text-align: center;
    padding: 30px;
    font-size: 18px;
  }
  #main{
    width: 80%;
    height: 500px;
    border: 1px solid red;
    margin: 0 auto;
  }

#span1{
  padding-left: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/work/student/ViewEnglishEcharts.vue